import { InjectionToken, Type } from '@angular/core';

export type AddToType = 'issue' | 'rfi' | 'punch';

/**
 * The record create panels the sheet viewer's Add to opens. ProjectsModule provides them, which keeps the forms (and
 * the map stacks they import) out of the viewer's own import graph.
 */
export const DRAWING_ADD_TO_PANELS = new InjectionToken<Record<AddToType, Type<unknown>>>('DRAWING_ADD_TO_PANELS');
